module.exports = __webpack_public_path__ + "77a2412ac6631bd9c284b8c8b2ba5333.png";